import { get } from './apiUtils';

const defaultUrl = '/ToxProfileChapters';

export default {
  getToxProfilChapterList: () => get(`${defaultUrl}`),
};
